import { Icon } from '@iconify/react';

type Props = {
  total: number;
  perPage: number;
  current: number;
  onChange?: (page: number) => void;
};

const Pagination = ({ total, perPage, current, onChange }: Props) => {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const pages = [];
  for (let i = 1; i <= totalPages; i++) pages.push(i);

  return (
    <div className="flex items-center justify-between mt-6">
      <div className="text-sm text-gray-500">
        Showing {(current - 1) * perPage + 1} to {Math.min(current * perPage, total)} of {total}{' '}
        entries
      </div>
      <div className="flex items-center gap-2">
        <button
          className="p-2 rounded-full bg-gray-100 text-gray-600"
          onClick={() => onChange && onChange(Math.max(1, current - 1))}
        >
          <Icon icon="mdi:chevron-left" className="w-5 h-5" />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={`w-8 h-8 rounded-full ${p === current ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-600'}`}
            onClick={() => onChange && onChange(p)}
          >
            {p}
          </button>
        ))}
        <button
          className="p-2 rounded-full bg-gray-100 text-gray-600"
          onClick={() => onChange && onChange(Math.min(totalPages, current + 1))}
        >
          <Icon icon="mdi:chevron-right" className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
